<app-panel-lateral (cargado)="refresca()"></app-panel-lateral>
<app-modal  (cargado)="refresca()"></app-modal>
<router-outlet></router-outlet>
<ngx-ui-loader text="{{'Realizando acción' | translate}}..." [bgsType]="'fading-circle'"
               [fgsColor]="'#4F46E5'"></ngx-ui-loader>
